export const SITE_PLACES = 'SITE_PLACES';



// WEBPACK FOOTER //
// ./src/store/modules/sitePlace/mutation-types.js